import { useQuery } from '@tanstack/react-query';
import { getInvoicesCountWithErrors } from 'Services/invoices';
import { trackError } from 'Utils/errorMonitoring';

export default function useInvoicesCountWithErrors() {
    const { data: invoicesCount = 0, isLoading } = useQuery({
        queryKey: ['invoices', 'count', 'with-errors'],
        queryFn: getInvoicesCountWithErrors,
        onError: (error) => trackError(error),
    });

    return {
        invoicesCount,
        isLoading,
    };
}
